<template>
  <div id="sysBanner">
    <eb-header></eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <ebUploadImage
          :uploadUrl="uploadUrl"
          @onUploadSuccess="onUploadSuccess"
          :text="text"
          height="22px"
          width="88px"
        />
        <el-button class="eb-button-orange eb-button-small" @click="init">取消修改</el-button>
        <el-button class="eb-button-orange eb-button-small" @click="editConst">保存生效</el-button>
      </div>
    </div>
    <div class="sysBanner-tips">请使用鼠标拖拽操作和排序</div>
    <div class="sys-banner-container">
      <div class="list-group">
        <div class="list-title">正在播放</div>
        <draggable class="list-group-drap" :list="constList" :options="{group: 'banner'}">
          <div class="list-group-item" v-for="(item, index) in constList" :key="index">
            <img class="item-img" :src="item.Path">
          </div>
        </draggable>
      </div>
      <div class="list-group">
        <div class="list-title">素材库</div>
        <draggable class="list-group-drap" :list="cosList" :options="{group: 'banner'}">
          <div class="list-group-item" v-for="(item, index) in cosList" :key="index">
            <img class="item-img" :src="item.Path">
            <el-button
              class="eb-button-orange eb-button-small delCos"
              @click="delConfirm(item)"
            >删除素材</el-button>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebUploadImage from '@/components/common/eb-upload-image';
import moment from 'moment';
import { getConstByKey, editConst } from '@/services/const-service';
import { getTengxunCosBanner, delTengxunCosBanner } from '@/services/tengxun-service';
export default {
  name: 'sysBanner',
  components: {
    ebHeader,
    ebUploadImage
  },
  data() {
    return {
      uploadUrl: '/tengxun/cos/banner?channel=tengxun-cos&date=' + moment().format('YYYYMMDD'),
      text: '上传广告',
      constList: [],
      cosList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([getConstByKey('banner'), getTengxunCosBanner()]);
        if (data1.returnCode === '01') {
          if (data1.const) {
            this.constList = this.handlerConst(JSON.parse(JSON.parse(data1.const.value).bannerList));
          }
        } else {
          this.$message.error('获取banner列表失败');
        }
        if (data2.returnCode === '01') {
          this.cosList = this.handlerCos(data2.data);
        } else {
          this.$message.error('获取块存储列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    handlerConst(arr) {
      let rArr = [];
      arr.forEach(element => {
        rArr.push({
          Path: element,
          Key: element
        });
      });
      return rArr;
    },
    handlerCos(arr) {
      let constArr = [];
      let rArr = [];
      this.constList.forEach(item => {
        constArr.push(item.Path);
      });
      arr.forEach(element => {
        if (!constArr.includes(element.Path)) {
          rArr.push(element);
        }
      });
      return rArr;
    },
    onUploadSuccess: function(data) {
      if (data.data.returnCode === '01') {
        this.$message.success('上传成功');
        this.init();
      } else {
        this.$message.error('上传失败');
      }
    },
    async editConst() {
      this.$root.layout.isLoading = true;
      let arr = [];
      this.constList.forEach(element => {
        arr.push(element.Path);
      });
      try {
        let { data } = await editConst('banner', JSON.stringify({ bannerList: JSON.stringify(arr) }));
        if (data.returnCode === '01') {
          this.$message.success('保存成功');
          this.init();
        } else {
          this.$message.error('保存失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    delConfirm(item) {
      this.$ebConfirm('确认删除素材吗?')
        .then(() => {
          this.delCos(item);
        })
        .catch(() => {});
    },
    async delCos(item) {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await delTengxunCosBanner(item);
        if (data.returnCode === '01') {
          this.$message.success('删除素材成功');
          this.editConst();
        } else {
          this.$message.error('删除素材失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    }
  }
};
</script>
<style lang="less" scoped>
#sysBanner {
  .sys-banner-container {
    padding: 30px 10px;
    display: flex;
    justify-content: space-around;
  }
  .list-group {
    width: 300px;
  }
  .list-title {
    font-size: 20px;
    text-align: center;
    padding-bottom: 20px;
  }
  .list-group-drap {
    border: 1px solid #ccc;
    min-height: 50px;
  }

  .list-group-item {
    cursor: move;
    border-bottom: 1px solid #ccc;
  }
  .item-img {
    max-width: 200px;
    max-height: 100px;
  }
  .eb-button-small {
    margin-left: 10px;
  }
  .delCos {
    float: right;
    margin-top: 35px;
    margin-left: 0;
  }
  .sysBanner-tips {
    padding-left: 40px;
    color: orange;
  }
}
</style>
